import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDom from "react-dom";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Breadcrumb, List, Button } from "antd";
import { MyIcon, noDataImg2 } from "../../common/baseConfig";

let Index = 5; //开始索引
export class Teacher extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    swiperData: [],
    isAuto: true,
    isShowBtn: true,
    firstIndex: 0,
    secondIndex: 0,
    secondList: [],
    listData: [],
    curPage: 1,
  }
  componentWillMount() {
    this.props.actions.fetchGetAllDisciplineInfo({
      Type: 0,
    })
    this.onLoadList();
  }
  componentWillUnmount() {
    this.clearSwiper();
  }
  componentDidMount() {
    this.props.actions.fetchGetTeacherBanner().then(res => {
      if (res.SuccessResponse) {
        let teachers = res.Data;
        //初始化swiper Banner
        if (teachers.length < 5) {
          this.setState({
            isShowBtn: false,
            swiperData: teachers
          });
          return;
        };
        let scroll = ReactDom.findDOMNode(this.refs.scroll);
        let afterData = teachers.slice(0, 5);
        let beforeData = teachers.slice(teachers.length - 5, teachers.length);
        let newData = [...beforeData, ...teachers, ...afterData];
        this.setState({
          swiperData: newData,
        })
        let len = newData.length;
        scroll.style.width = `${216 * len + 30 * (len - 1)}px`;
        scroll.style.transform = `translateX(${-246 * Index}px)`;

        if (this.state.isAuto) {
          this.startSwiper();
        }
      }
    });
  }
  componentDidUpdate() {
    if (!this.state.isAuto) {
      setTimeout(() => {
        this.startSwiper();
      }, 3000)
    }
  }
  startSwiper() {
    let scroll = ReactDom.findDOMNode(this.refs.scroll);
    this.setState({
      isAuto: true,
    })
    this.timer = setInterval(() => {
      Index++;
      scroll.style.transition = 'all 1.5s ease-in-out';
      scroll.style.transform = `translateX(${-246 * Index}px)`;
      if (Index === this.state.swiperData.length - 5) {
        setTimeout(() => {
          Index = 5;
          scroll.style.transition = 'none';
          scroll.style.transform = `translateX(${-246 * Index}px)`;
        }, 1500)
      }
    }, 3000)

  }
  clearSwiper() {
    let scroll = ReactDom.findDOMNode(this.refs.scroll);
    this.setState({
      isAuto: false
    })
    scroll.style.transition = 'none';
    clearInterval(this.timer);
  }
  onLeftBtn() {
    if (this.state.isAuto) {
      this.clearSwiper();
    }
    let scroll = ReactDom.findDOMNode(this.refs.scroll);
    Index--;
    scroll.style.transition = 'all 0.3s ease-in-out';
    scroll.style.transform = `translateX(${-246 * Index}px)`;
    if (Index === 0) {
      setTimeout(() => {
        Index = this.state.swiperData.length - 10;
        scroll.style.transition = 'none';
        scroll.style.transform = `translateX(${-246 * Index}px)`;
      }, 300)
    }

  }
  onRightBtn() {
    if (this.state.isAuto) {
      this.clearSwiper();
    }
    let scroll = ReactDom.findDOMNode(this.refs.scroll);
    Index++;
    scroll.style.transition = 'all 0.3s ease-in-out';
    scroll.style.transform = `translateX(${-246 * Index}px)`;
    if (Index === this.state.swiperData.length - 5) {
      setTimeout(() => {
        Index = 5;
        scroll.style.transition = 'none';
        scroll.style.transform = `translateX(${-246 * Index}px)`;
      }, 300)
    }
  }
  onFirstClick(index) {
    this.setState({
      firstIndex: index,
      secondIndex: 0,
    }, () => {
      this.onLoadList();
    })
  }
  onSecondClick(index) {

    this.setState({
      secondIndex: index
    }, () => {
      this.onLoadList();
    })
  }
  onLoadList() {
    const { firstIndex, secondIndex, } = this.state;
    let discipline_ID = 0;
    if (secondIndex === 0) {
      discipline_ID = firstIndex;
    } else {
      discipline_ID = secondIndex;
    }
    this.props.actions.fetchGetTeacherList({
      PageSize: 4,
      PageIndex: this.state.curPage,
      PageStatus: 1,
      Discipline_ID: discipline_ID,
    })
  }
  renderItem(item) {
    return (
      <div key={item.ID} className="common-teacher-list-item">
        <div className="item-img">
          {
            item.ImagePhoto && <img src={item.ImagePhoto ? item.ImagePhoto + '?x-oss-process=image/resize,m_fixed,h_260,w_188' : ''} alt="" className="photo" onClick={() => {
              this.props.history.push(`/teachers/detail/${item.ID}`);
            }} />
          }
        </div>
        <div className="item-detail">
          <p className="name">
            <span>{item.Name || "匿名"}</span><span>{item.Title || ""}</span>
          </p>
          <p className="intro">
            {item.Introduction || ""}
          </p>
          <Button className="checkBtn" onClick={() => {
            this.props.history.push(`/teachers/detail/${item.ID}`);
          }}>查看详情</Button>
        </div>
      </div>
    )
  }
  render() {
    let {
      swiperData,
      isShowBtn,
      firstIndex,
      secondIndex,
      secondList,
      curPage,
    } = this.state;
    const {
      fetchGetAllDisciplineInfoSuccess,
      fetchGetAllSecondListByIDs,
    } = this.props.course;
    const {
      fetchGetTeacherListTotal,
      fetchGetTeacherListPending,
      fetchGetTeacherListSuccess,
    } = this.props.common
    if (firstIndex !== 0 && fetchGetAllSecondListByIDs) {
      secondList = fetchGetAllSecondListByIDs[firstIndex];
    }

    return (
      <div className="common-teacher">
        <div className="common-teacher-top">
          <div className="common-teacher-breadcrumb">
            <Breadcrumb separator=">">
              <Breadcrumb.Item href="/">网校</Breadcrumb.Item>
              <Breadcrumb.Item>师资阵容</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className="common-teacher-swiper">
            {
              isShowBtn && <div className="common-teacher-swiper-left-btn" onClick={this.onLeftBtn.bind(this)}>
                <MyIcon type="iconwangzuo" className="arrow" />
              </div>
            }
            <div className="common-teacher-swiper-wrap">
              <div className="common-teacher-swiper-scroll" ref="scroll">
                {
                  swiperData.length > 0 && swiperData.map((item, i) => (
                    <div className="common-teacher-swiper-scroll-item" key={i} onClick={() => {
                      this.props.history.push(`/teachers/detail/${item.ID}`);
                    }}>
                      <div className="scroll-item-img">
                        {
                          item.ImagePhoto && <img src={item.ImagePhoto ? item.ImagePhoto + '?x-oss-process=image/resize,m_fixed,h_300,w_216' : ''} alt="" className="photo" />
                        }
                      </div>
                      <p className="scroll-item-name">
                        <span>{item.Name || "匿名"}</span><span>{item.Title || ""}</span>
                      </p>
                    </div>
                  ))
                }
              </div>
            </div>
            {
              isShowBtn && <div className="common-teacher-swiper-right-btn" onClick={this.onRightBtn.bind(this)}>
                <MyIcon type="iconwangyou-" className="arrow" />
              </div>
            }
          </div>

        </div>
        <div className="common-teacher-category">
          {
            fetchGetAllDisciplineInfoSuccess && fetchGetAllDisciplineInfoSuccess.length > 0 &&
            <div className="subject">
              <p>一级分类:</p>
              <ul>
                {
                  fetchGetAllDisciplineInfoSuccess.map(item => (
                    <li className={firstIndex === item.ID ? 'active' : ''} key={item.ID} onClick={this.onFirstClick.bind(this, item.ID)}>{item.Name}</li>
                  ))
                }
              </ul>
            </div>
          }
          {
            secondList && secondList.length > 0 &&
            <div className="subject">
              <p>二级分类:</p>
              <ul>
                {
                  secondList.map(item => (
                    <li className={secondIndex === item.ID ? 'active' : ''} key={item.ID} onClick={this.onSecondClick.bind(this, item.ID)}>{item.Name}</li>
                  ))
                }
              </ul>
            </div>
          }
        </div>
        {
          fetchGetTeacherListSuccess && <div className="common-teacher-list">
            {
              fetchGetTeacherListSuccess.length > 0 ? <List
                itemLayout="horizontal"
                size="large"
                pagination={{
                  onChange: page => {
                    this.setState(
                      {
                        curPage: page,
                      },
                      () => {
                        this.onLoadList();
                      }
                    )
                  },
                  current: curPage,
                  total: fetchGetTeacherListTotal,
                  pageSize: 4,
                }}
                loading={fetchGetTeacherListPending}
                dataSource={fetchGetTeacherListSuccess}
                renderItem={item => this.renderItem(item)}
              /> : <div className="nodata">
                  <img src={noDataImg2} alt="" />
                  <p>暂无老师数据</p>
                </div>
            }
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
    course: state.course,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Teacher);



// WEBPACK FOOTER //
// ./src/features/common/Teacher.js